import React from 'react'
import { ToastContainer as ReactToastContainer } from 'react-toastify'

import { CloseButton } from './CloseButton'

export const ToastContainer: React.FC = () => {
  return (
    <ReactToastContainer autoClose={5000} newestOnTop={true} closeButton={CloseButton as any} />
  )
}
